import { useCallback, useMemo } from "react";
import useTagsAll from "../api/api-hooks/tags/useTagsAll";

const useAllTags = (moduleAPIName, disabled) => {
  const { tags, tagsLoading } = useTagsAll(moduleAPIName, disabled);

  const tagsMap = useMemo(() => {
    if (tagsLoading) return null;

    const map = {};

    for (let i = 0; i < tags?.length ?? 0; i++) {
      const tag = tags[i];

      map[tag.id] = tag;

      map[tag.id].icon = "mdi mdi-tag";
    }

    return map;
  }, [tags, tagsLoading]);

  const getTagNames = useCallback(
    (ids) => {
      if (tagsLoading) return;

      if (Array.isArray(ids)) {
        return ids.map((id) => tagsMap[id]?.Name).join(", ");
      }

      return tagsMap[ids]?.Name;
    },
    [tagsLoading, tagsMap]
  );

  const getTags = useCallback(
    (ids) => {
      const tags = [];

      if (tagsLoading) return tags;

      for (let i = 0; i < ids.length; i++) {
        const currentID = ids[i];

        if (tagsMap[currentID]) {
          tags.push(tagsMap[currentID]);
        }
      }

      return tags;
    },
    [tagsLoading, tagsMap]
  );

  return { tags, tagsLoading, tagsMap, getTags, getTagNames };
};

export default useAllTags;
